/**
 * Fixed-timestep game loop.
 *
 * Physics always advances in equal slices so ball behaviour is identical on a
 * 60Hz laptop and a 144Hz monitor. Rendering happens once per animation frame.
 */

const STEP = 1 / 120;
const MAX_FRAME = 0.2;
const MAX_STEPS = 12;

export function createLoop({ update, render }) {
  let handle = 0;
  let last = 0;
  let accumulator = 0;
  let running = false;

  function frame(now) {
    if (!running) return;
    handle = requestAnimationFrame(frame);

    const time = now / 1000;
    let delta = last ? time - last : STEP;
    last = time;
    if (delta > MAX_FRAME) delta = MAX_FRAME;

    accumulator += delta;
    let steps = 0;
    while (accumulator >= STEP && steps < MAX_STEPS) {
      update(STEP);
      accumulator -= STEP;
      steps += 1;
    }
    // If we blew the step budget (background tab, slow device) drop the debt
    // rather than spiralling.
    if (steps >= MAX_STEPS) accumulator = 0;

    render(delta);
  }

  return {
    start() {
      if (running) return;
      running = true;
      last = 0;
      accumulator = 0;
      handle = requestAnimationFrame(frame);
    },
    stop() {
      running = false;
      if (handle) cancelAnimationFrame(handle);
      handle = 0;
    },
    get running() {
      return running;
    },
  };
}
